import React from 'react'
import { logoNoBackground, preloadAllImages } from 'assets'
import { AuthBootSplash } from 'components/auth/AuthBootSplash'

interface MainLoadingProps {
  fullscreen?: boolean
}

preloadAllImages()

export const MainLoading: React.FC<MainLoadingProps> = () => (
  <AuthBootSplash logoSrc={logoNoBackground} />
)
